/**
 * Google Dictionary (by Google)
 *
 * Exposes its injected definition-popup stylesheet.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 4.2.6.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'mgijmajocgfcbeboacabfgobmjgjcoja';
export const googleDictionary: ExtensionDefinition = {
  id: ID,
  name: "Google Dictionary (by Google)",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 2000000,
  notes: "Exposes its injected definition-popup stylesheet.",
  signals: [
    { id: 'war-content-min-css', kind: 'web-accessible-resource',
      description: 'Fetch content.min.css, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'content.min.css') },
  ],
};
